import { Box, Grid, LinearProgress, Typography } from '@mui/material'
import { useStyles } from './styles'
import { AnswerData } from '../../../../../../../../service/questionarie/response'
import { useTranslation } from 'react-i18next'
import { CSSProperties } from 'react'

export const OptionQuestion = ({ answersDropDown, description, score, amountSelected, amountRecurrence, percentage, correctOption, answersOpen, iconUrl, recurrences }: AnswerData) => {
  const styles = useStyles()
  const { t } = useTranslation()

  const getSubNames = (configAnswer: string, subCategorytext: string) => {

    const namesArray = configAnswer.split(',').map(item => item.trim())
    const names = namesArray.slice(1).map(item => item);

    const result = names.join(" / ");

    const resultWithText = names.length ? `${result} ${subCategorytext.trim().length > 0 ? ` : ${subCategorytext}` : ''}` : subCategorytext.trim().length > 0 ? subCategorytext : ''

    return (
      <>
        <Typography variant='mediumBold'>{namesArray[0]}</Typography>
        <Box sx={styles.dropList}>
          <Typography variant='body2'>{resultWithText}</Typography>
        </Box>
      </>
    );
  }


  return (
    <>
      {answersDropDown.length == 0 ?
        <>
          <Box sx={styles.container}>
            {answersOpen?.length === 0 && (description || iconUrl) && (
              <>
                <Box sx={styles.title}>
                  {!!iconUrl && <img style={styles.image as CSSProperties} src={iconUrl} alt="icon_multiple" />}
                  <Typography variant='mediumBold' sx={styles.titleAnswer}>{`${description ? description : ''} - ${score} ${correctOption ? `- ${t('Questionarie.fields.correctOption')}` : ''}`}</Typography>
                </Box>

                <Box sx={styles.progressAndAlert}>
                  <Box sx={styles.flexProgressAndAlert}>
                    <Box sx={styles.progressContainer({ progress: percentage })}>
                      <Typography>{percentage}% ({amountSelected})</Typography>
                      {percentage > 0 &&
                        <LinearProgress
                          variant="determinate"
                          value={percentage}
                          sx={styles.linearProgress}
                        />
                      }
                    </Box>
                    {!!(amountRecurrence > 0) && <Typography sx={styles.alerts}>{amountRecurrence} {t('Questionarie.fields.recurrenceAlerts')}</Typography>}
                  </Box>
                </Box>
              </>
            )}
            {answersOpen?.length !== 0 && !iconUrl && (
              <Box sx={styles.openAnswerContainer}>
                <Box sx={styles.freeAnswerText}>
                  {answersOpen.map(answer => (
                    <Typography sx={styles.displayBlock} variant='mediumBold'>{`${answer} - ${score} ${correctOption ? `- ${t('Questionarie.fields.correctOption')}` : ''}`}</Typography>
                  ))}
                </Box>

                <Box sx={styles.title}>
                  <Box>
                    {!!(amountRecurrence > 0) && <Typography sx={styles.freeAlerts}>{amountRecurrence} {t('Questionarie.fields.recurrenceAlerts')}</Typography>}
                    {recurrences?.length <= 3 && recurrences?.map((recurrence, index) => (
                      <Typography sx={styles.alertText} key={index}>{recurrence}</Typography>
                    ))}
                  </Box>
                </Box>
              </Box>
            )}
            {answersOpen?.length === 0 && !description && !iconUrl && (
              <Typography variant='mediumBold'>{t('Questionarie.fields.noDataFound')}</Typography>
            )}
          </Box>
          {
            recurrences?.length != 0 && (
              <Box sx={[(recurrences?.length <= 3) ? styles.container : null]}>
                <Box sx={[(recurrences?.length <= 3) ? styles.smallDate : styles.bigDate]}>
                  {recurrences?.map((recurrence, index) => (
                    <Typography key={index} sx={[styles.alertText, recurrences?.length <= 3 ? null : styles.marginRigt, (answersOpen?.length !== 0 && recurrences?.length <= 3) ? styles.hiden : null]}>
                      {`${(index !== 0 && recurrences?.length > 3) ? ' - ' : ''}${recurrence}`}
                    </Typography>
                  ))}
                </Box>
              </Box>
            )
          }
        </>
        :
        <Box sx={styles.containerCatalog}>
          {answersDropDown.map((item, index) => (
            <Grid spacing={3} container>
              {index > 0 &&
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                  <Box sx={styles.line} />
                </Grid>
              }
              {item.map(subItem => (
                <Grid item xl={item.length > 1 ? 6 : 12} lg={item.length > 1 ? 6 : 12} md={12} sm={12} xs={12} >
                  <Box>{getSubNames(subItem.answerConfig ?? '', subItem.listText ?? '')}</Box>
                </Grid>
              ))}
            </Grid>
          ))}
        </Box>
      }
    </>
  )
}
